import { render, staticRenderFns } from "./Testing.vue?vue&type=template&id=1f249afe&"
import script from "./Testing.vue?vue&type=script&lang=js&"
export * from "./Testing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports